export const environment = {
  production: false,
  baseUrl: 'https://restcountries.eu/rest/v2',
  gc_api_key: 'AIzaSyBhRDuHVTuA3Td8iSyc3-SXnidc33NmaXM',
};
